export default __webpack_public_path__ + "static/media/all-audios.01fc6d5a.mp3";